import Vue from 'vue'
import App from './App.vue'
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';
import './assets/css/fontface.css';
import './assets/css/style.css';
import VueQrcodeReader from 'vue-qrcode-reader'
import VueOnsen from 'vue-onsenui'; // This already imports 'onsenui'
import VueMask from 'v-mask';

Vue.use(VueMask);

Vue.config.productionTip = false
import VueSocketIO from 'vue-socket.io'

Vue.use(VueOnsen);
Vue.use(VueQrcodeReader);

Vue.prototype.$hnk00_uri = "https://hnk00.cyma.digital";
// Vue.prototype.$hnk00_uri = "http://localhost:5003";
//Vue.prototype.$hnk00_uri = "http://localhost:5003";

Vue.use(new VueSocketIO({
  debug: true,
  connection: Vue.prototype.$hnk00_uri ,
}));

// const app =
 new Vue({
  render: h => h(App),
  data() { 
    return { 
    }
  },
  methods: {

    errorCamera: function() {
      window.console.warn('Camera permission is not turned on');
    },
    successCamera: function( status ) {
      if( !status.hasPermission ) window.console.warn("Camera permission is turned on");
    }
  }
}).$mount('#app')


